(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
if (!customElements.get('sd-announcement-bar')) {
  customElements.define('sd-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const details = this.querySelector('details');
      const summary = details.querySelector('summary');
      const opener = this.querySelector('[data-sd-announcement-open]');
      let returnFocus = summary;
      const close = () => { details.open = false; (returnFocus.getClientRects().length ? returnFocus : summary).focus({preventScroll:true}); };
      opener?.addEventListener('click', () => { returnFocus = opener; details.open = !details.open; if (details.open) this.querySelector('[data-sd-announcement-heading]').focus({preventScroll:true}); }, options);
      summary.addEventListener('click', () => { returnFocus = summary; }, options);
      this.querySelector('[data-sd-announcement-close]').addEventListener('click', close, options);
      details.addEventListener('toggle', () => { opener?.setAttribute('aria-expanded', String(details.open)); }, options);
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && details.open) { event.preventDefault(); close(); } }, options);
      document.addEventListener('click', (event) => { if (details.open && !this.contains(event.target)) details.open = false; }, options);
      if (this.querySelector('[role="status"], [role="alert"]')) details.open = true;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-equipment-families"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('[data-sd-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const filters = catalog.querySelector('.sd-catalog-filters');
      if (!filters) return;
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-sd-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        catalog.querySelectorAll('[data-sd-application]').forEach(card => {
          card.hidden = button.dataset.sdFilter !== 'all' && card.dataset.sdApplication !== button.dataset.sdFilter;
        });
        catalog.querySelector('[data-sd-filter-status]').textContent = button.textContent.trim();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-material-lifts"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('[data-sd-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const filters = catalog.querySelector('.sd-catalog-filters');
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-sd-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        catalog.querySelectorAll('[data-sd-application]').forEach(card => {
          card.hidden = button.dataset.sdFilter !== 'all' && card.dataset.sdApplication !== button.dataset.sdFilter;
        });
        catalog.querySelector('[data-sd-filter-status]').textContent = button.textContent.trim();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-service-page"]) return;
  try {
    
  const quoteMessage = document.querySelector('[data-sd-quote-message]');
  if (quoteMessage && !quoteMessage.value.trim()) {
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const sku = params.get('sku');
    const quantity = params.get('quantity');
    const model = params.get('model');
    const assembly = params.get('assembly');
    const partName = params.get('part_name');
    const isFrench = quoteMessage.dataset.sdLocale === 'fr';
    const pieces = [];
    if (product) pieces.push(product.slice(0, 300));
    if (sku) pieces.push('SKU: ' + sku.slice(0, 100));
    if (partName) pieces.push((isFrench ? 'Pièce : ' : 'Part: ') + partName.slice(0, 200));
    if (model) pieces.push((isFrench ? 'Modèle : ' : 'Model: ') + model.slice(0, 200));
    if (assembly) pieces.push((isFrench ? 'Assemblage : ' : 'Assembly: ') + assembly.slice(0, 200));
    if (quantity && /^\d{1,6}$/.test(quantity)) pieces.push(quoteMessage.dataset.sdQuantityLabel + ': ' + quantity);
    quoteMessage.value = pieces.join(' · ');
  }

  } catch(e) { console.error(e); }
})();
})();
